import { render, staticRenderFns } from "./packsDetails.vue?vue&type=template&id=68cf32ce&scoped=true&"
import script from "./packsDetails.vue?vue&type=script&lang=js&"
export * from "./packsDetails.vue?vue&type=script&lang=js&"
import style0 from "./packsDetails.vue?vue&type=style&index=0&id=68cf32ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf32ce",
  null
  
)

export default component.exports